module.exports = __webpack_public_path__ + "img/9.0aa89fe9.png";